// Chỉ neo phần tử thường có lúc mở form. Nếu mở lại bản nháp (đã quét/chốt),
// useTour sẽ tự lọc bỏ bước target không còn trong DOM.
function buocFormThuMua() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Form thu mua",
      content:
        "Form xếp theo từng loại bơ (khối). Với mỗi loại: quét Sọt → chọn loại bơ → nhập khối lượng/giá → bấm Xong. Có thể thêm nhiều loại bơ, hoặc thêm Sọt khi một Sọt đầy giữa chừng. Dở dang thì Lưu nháp.",
    },
    {
      target: "#tour-form-hop-tac-xa",
      title: "Bước 2 · Hợp tác xã (nếu có)",
      content:
        "Nếu lượt này qua hợp tác xã, chọn HTX trước khi cân. Để trống nếu thu trực tiếp từ chủ vườn.",
      placement: "bottom",
    },
    {
      target: "#tour-form-quet-sot",
      title: "Bước 3 · Quét Sọt",
      content:
        'Bấm "Quét QR Sọt" cho lần cân đầu của loại bơ. Sọt đầy giữa chừng thì dùng "Thêm sọt" để cân phần còn lại vào Sọt khác (cùng loại bơ).',
      placement: "top",
    },
    {
      target: "#tour-form-xong",
      title: "Bước 4 · Chốt từng loại bơ",
      content:
        'Đủ loại bơ, Sọt, khối lượng và giá → bấm "Xong" để chốt khối. Cần loại khác → "Thêm loại bơ" bên dưới sau khi chốt.',
      placement: "top",
    },
    {
      target: "#tour-form-luu-giao-dich",
      title: "Bước 5 · Lưu phiếu",
      content:
        'Khi mọi loại bơ đã "Xong", bấm lưu để tạo phiếu và sang xác nhận thanh toán. Chưa xong hết thì dùng "Lưu nháp" phía trên để quay lại sau.',
      placement: "top",
    },
  ];
}

export default buocFormThuMua;
